export enum EVENT {
  INTERACTION = 'interaction',
  ENGAGEMENT = 'engagement'
}

export enum CATEGORY {
  UNIVERSAL_BAR = 'Platform:BW-UniversalBar',
  TOOLS_MENU = 'Platform:BW-ToolsMenu',
  FREQUENCY = 'Frequency',
  SIDEMENU = 'Platform:BW_sidemenu',
  ONBOARDING = 'Platform:BW-Onboarding',
  MIDDLE_PAGE = 'Platform:BW-MiddlePage',
  HEADER = 'Platform:Header'
}

export enum ACTION {
  CLICK_LOGO = 'Click:HotLogo',
  CLICK_MENU_COMMUNICATION = 'Click:CommunicationMenu',
  CLICK_MENU_COLLABORATOR_AREAS = 'Click:CollaboratorAreasMenu',
  CLICK_MENU_PROFILE = 'Click:MenuProfile',
  CLICK_MENU_TOOLS = 'Click:MenuTools',
  CLICK_MY_PANEL = 'Click:MyPanel',
  CLICK_MY_PRODUCTS = 'Click:MyProducts',
  CLICK_MY_SALES = 'Click:MySales',
  CLICK_BALANCE = 'Click:Balance',
  CLICK_TOOLS = 'Click:Tools',
  CLICK_ALL_TOOLS = 'Click:AllTools',
  CLICK_AUDIENCE = 'Click:MenuAudience',
  CLICK_REPORTS = 'Click:Reports',
  CLICK_CHECKOUT_BUILDER = 'Click:CheckoutBuilder',
  CLICK_LISTBOSS = 'Click:Listboss',
  CLICK_LINKS_MANAGER = 'Click:LinksManager',
  CLICK_KLICKPAGES = 'Click:Klickpages',
  CLICK_KLICKSEND = 'Click:Klicksend',
  CLICK_WEBINAR = 'Click:Webinar',
  ACCESS_KLICKPAGES = 'Access:Klickpages',
  ACCESS_KLICKSEND = 'Access:Klicksend',
  ACCESS_WEBINAR = 'Access:Webinar'
}
